import React, { Component } from 'react';
import css from '../ProjectPage/ProjectPage.module.scss';
import Header from '../ProjectPage/Header';
import ProjectItem from '../ProjectItem.js';

import ImgG1 from './assets/G1.png';
import ImgG2 from './assets/G2.png';
import ImgG3 from './assets/G3.png';
import ImgG4 from './assets/G4.png';
import ImgG5 from './assets/G5.png';
import ImgG6 from './assets/G6.jpg';

import ImgUrbanMobility from '../assets/UrbanMobility.png';
import ImgBeboTournaments from '../assets/BeboTournaments.jpg';

export default class Twitch extends Component {

  render () {
      return (
        <div className={css.projectPage}>
          <Header
            title='Climate Impact Dashboard'
            year='2020'
            position='Freelance Product Manager & Designer'
          />
          <div className={css.content}>
            <img src={ImgG1} alt='Climate Dashboard' />
            <div className={css.text}>
              <p>I worked with a Dutch green startup to help pivot their food-focused carbon tracking product from the consumer market to B2B through the creation of a new corporate climate impact dashboard. Restaurants, food brands, caterers, and corporations can use this new dashboard to analyse their food purchases and recipes to help them discover their current CO₂ impact, ways they can reduce their impact with alternative products, and purchase offsets.</p>
              <p>Using early sales conversations and feedback from prospective clients, I helped the team develop a product specification document and wrote user stories to clearly communicate the product’s features to all stakeholders. We scoped out a 3 page web app with each page focusing on one of the core unique selling points: track, reduce, and offset.</p>
              <p>The tracking page is the heart of the product where users can upload their data, view visualisations of their impact, and get useful infographics that put their impact in perspective for internal and external stakeholders. I worked with a branding designer to develop a vibrant colour scheme for the UI that’s powerful, distinctive, and immersive. Diving into the data should be empowering and inviting, but with such a dramatic colour scheme it was important to ensure that symbolic colours were consistent across every page of the product.</p>
            </div>
            <img src={ImgG2} alt='Impact Tracking' />
            <div className={css.text}>
              <p>Taking action to reduce climate change should be as visually gratifying as it is impactful. I introduced a  progress meter to the Reduce page so users that make pledges to reduce their CO₂ emissions can see a visualisation of their progress in a glance. </p>
            </div>
            <img src={ImgG3} alt='Impact Reduction' />
            <div className={css.text}>
              <p>On the Offset page, I introduced a progress meter of sorts with a visual calculation of the offset costs—as users fill out the form, the formula fills up until the final price can be calculated from all the user’s choices. This visual feedback encourages users to complete the form, see how many steps are left, and how their choices impact cost. </p>
            </div>
            <img src={ImgG4} alt='Impact Offsetting' />
            <div className={css.text}>
              <p>The product was designed to be fully accessible via mobile web. Each page was designed with a single purpose in mind which aided in the transition to mobile. Colour schemes were also coordinated to connect pages within a flow—blues for tracking, purple for reduction, greens for offsetting, yellows for onboarding, and peach for payment.</p>
            </div>
            <img src={ImgG5} alt='Mobile Web' />
            <div className={css.text}>
              <p>After completing the dashboard designs, I worked with the client to design and write copy for a landing page which communicates the decades of cutting edge climate research experience of the team with the practical application of data that the product hopes to provide to customers.</p>
            </div>
            <img src={ImgG6} alt='Landing Page' />
          </div>
          <div className={css.moreWork}>
            <header>More Projects</header>
              <ul className={css.moreWorkList}>
                <ProjectItem
                  title='Urban Mobility App'
                  description='EV ridesharing app and vehicle designs'
                  position='Freelance Product & Brand Designer'
                  img={ImgUrbanMobility}
                  link='UrbanMobility'
                />
                <ProjectItem
                  title='Bebo Tournaments'
                  description='Esports for Everybody'
                  position='Product Designer / Booth Design'
                  img={ImgBeboTournaments}
                  link='BeboTournaments'
                />
              </ul>
          </div>
        </div>
      )
   }
}
